<app-navbar></app-navbar>
    <div class="container mt-3">
        <div class="row">
            <div class="col-lg-8">
                @if(isLoading()) {
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '45px', 'margin-bottom': '15px', 'width': '100%' }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '40px', 'width': '100%' }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '15px', 'width': '20%' }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="2" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '15px', 'width': '100%' }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '10px', 'margin-top': '25px', 'width': '100%' }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="3" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '15px', 'width': '80%' }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '10px', 'margin-top': '25px', 'width': '100%' }"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="3" appearance="line" [theme]="{ 'height': '25px', 'margin-bottom': '15px', 'width': '80%' }"></ngx-skeleton-loader>
                }@else{
                    <div class="card mt-2 rounded-3 border-cstm">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="inter fs-7 mb-2 fw-medium breadcrumb mb-4">
                                    <a [routerLink]="['/']" class="text-decoration-none" title="Home">
                                        <strong>Home</strong>
                                    </a>
                                    <img src="assets/icons/arrow_right.svg" alt="breadcrumb"> 
                                    <a [routerLink]="['/careers']" class="text-decoration-none" title="Career">
                                        <strong>Careers</strong>
                                    </a>
                                    <img src="assets/icons/arrow_right.svg" alt="breadcrumb">
                                    <span class="text-muted" [title]="career()?.title!">{{career()?.title! | truncate: 30}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <h3 class="fs-3 fw-semibold p-0 mt-0 mb-3">{{career()?.title! | truncate: 70}}</h3>
                            </div>
                        </div>
                        <div class="inter text-muted fs-6 fw-medium mb-2">
                            <span class="me-4" [title]="career()?.workLocation!">
                                <img class="icon-sm" src="assets/icons/location.svg" alt="Work Location">
                                {{career()?.workLocation! | truncate: 13}}
                            </span>
                            <span class="me-4">
                                <img class="icon-sm" src="assets/icons/group.svg" alt="Department">
                                {{career()?.department!}}
                            </span>
                            <span class="me-4">
                                <img class="icon-sm" src="assets/icons/work.svg" alt="Job Type">
                                {{career()?.jobType! | titlecase}}
                            </span>
                            <span class="me-4">
                                <img class="icon-sm" src="assets/icons/clock_dark.svg" alt="Job Level">
                                {{career()?.jobLevel!}}
                            </span>
                            <span class="me-4">
                                <img class="icon-sm" src="assets/icons/globe.svg" alt="Work Setup">
                                {{career()?.workSetup! | titlecase}}
                            </span>
                        </div>
                        <h5 class="mt-5 mb-3 fw-semibold"><img class="icon-md" src="assets/icons/pencil.svg" alt="Job Description"> Job Description</h5>
                        <p class="inter fs-6 lh-lg mb-0">{{career()?.description}}</p>
                    </div>
                    <div class="card mt-4 rounded-3 border-cstm">
                        <h5 class="mt-0 mb-4 fw-semibold"><img class="icon-md" src="assets/icons/check.svg" alt="Duties and Responsibilities"> Duties and Responsibilities</h5>
                        <ul class="ps-3 inter fs-6 mb-0">
                            @for (obj of career()?.duties; track obj) {
                                <li class="mb-3 lh-lg">{{obj}}</li>
                            }
                        </ul>
                    </div>
                    <div class="card mt-4 rounded-3 border-cstm">
                        <h5 class="mt-0 mb-4 fw-semibold"><img class="icon-md" src="assets/icons/magnify.svg" alt="Qualifications"> Qualifications</h5>
                        <ul class="ps-3 inter fs-6 mb-0">
                            @for (obj of career()?.qualifications; track obj) {
                                <li class="mb-3 lh-lg">{{obj}}</li>
                            }
                        </ul>
                    </div>
                    <div class="card mt-4 mb-4 rounded-3 border-cstm">
                        <h5 class="mt-0 mb-4 fw-semibold"><img class="icon-md" src="assets/icons/location.svg" alt="Vacant Areas"> Vacant Areas</h5>
                        <ul class="ps-3 inter fs-6 mb-0">
                            @for (obj of career()?.vacantArea; track obj) {
                                <li class="mb-3 lh-lg">{{obj}}</li>
                            }
                        </ul>
                    </div>
                    @if(career()?.bnps!.length > 0){
                        <div class="row mb-5 mt-4">
                            <div class="col-lg-12">
                                <h3 class="fs-4 fw-semibold">Perks and Benefits</h3>
                                <p class="text-secondary inter fs-6">Benefits awaits you at Bewell</p>
                            </div>
                            @for (obj of career()?.bnps; track obj.bnp) {
                                <div class="col-lg-3">
                                    <div class="pnb">
                                        <img [src]="'assets/icons/' + obj.img" alt="Benefits and Perks">
                                        <span class="fs-6 text-secondary mt-2 inter">{{obj.bnp}}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                }
            </div>
            <div class="col-lg-4">
                <div class="mt-2">
                    <form [formGroup]="form" (ngSubmit)="apply()">
                        <div class="inter fs-7 border border-cstm rounded-3 p-4">
                            <h5 class="p-0 mt-0 mb-3 fw-semibold">Apply Now</h5>
                            <div class="fw-medium">Please send us your CV to apply for this job post.</div>
                            <div class="mt-3 apply-msg">
                                @if(isSent()) {
                                    <div class="alert alert-success inter mb-0" role="alert">Thank you, we have received your application.</div>
                                }
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group mb-1">
                                        <label for="find-by" class="fs-7 pb-1 fw-medium">How did you find Bewell?</label>
                                        <select id="find-by" class="form-select form-control shadow-none inter" placeholder="Select Option" formControlName="findBy">
                                            @for (obj of findBy; track obj) {
                                                <option [value]="obj" [disabled]="obj == 'Select Option'">{{capitalize(obj)}}</option>
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 mt-4">
                                <div class="col-lg-6">
                                    <div class="form-group" [ngClass]="{'has-error': form.controls.firstname.touched && form.controls.firstname.invalid}">
                                        <label for="firstname" class="fs-7 pb-1 fw-medium">Firstname</label>
                                        <input type="text" id="firstname" class="form-control" spellcheck="false" placeholder="Firstname" formControlName="firstname" autocomplete="false">
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group" [ngClass]="{'has-error': form.controls.lastname.touched && form.controls.lastname.invalid}">
                                        <label for="lastname" class="fs-7 pb-1 fw-medium">Lastname</label>
                                        <input type="text" id="lastname" class="form-control" spellcheck="false" placeholder="Lastname" formControlName="lastname" autocomplete="false">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="mb-4">
                                        <div class="form-group" [ngClass]="{'has-error': form.controls.email.touched && form.controls.email.invalid}">
                                            <label for="email" class="fs-7 pb-1 fw-medium">Email</label>
                                            <input type="text" id="email" class="form-control" spellcheck="false" placeholder="Email" formControlName="email" autocomplete="false">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="mb-4">
                                        <div class="form-group" [ngClass]="{'has-error': form.controls.phone.touched && form.controls.phone.invalid}">
                                            <label for="phone-no" class="fs-7 pb-1 fw-medium">Phone No</label>
                                            <input type="text" id="phone-no" class="form-control" spellcheck="false" placeholder="Phone No." formControlName="phone" autocomplete="false">
                                            <span class="form-text">Must be 11 digit to be exact.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="fw-semibold mb-1">Please attach your Resume or CV here</div>
                                <span class="text-muted fs-7">PDF or document. Max 10 MB per file.</span>
                                <input class="form-control mt-4 mb-4" type="file" (change)="selectFile($event)" formControlName="cvOrResume">
                            </div>
                            <div class="mb-3">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="agree" (change)="agree($event)" formControlName="agree">
                                    <label class="form-check-label" for="agree">
                                        I agree with the <a class="text-decoration-none" [routerLink]="['/privacy-policy']">privacy and policy</a> statement.
                                    </label>
                                </div>
                            </div>
                            <div class="mb-3">
                                <ngx-turnstile formControlName="captchaToken" [siteKey]='siteKey' (resolved)='captchaResponse($event)' theme="auto" [tabIndex]="0" [size]="'flexible'" [retry]="'auto'" [refreshExpired]="'auto'"></ngx-turnstile>
                            </div>
                            <div class="d-grid gap-2" [ngClass]="{'disabled': form.invalid || isApplying()}">
                                <button type="submit" class="btn btn-block btn-dark rounded-2 fs-7 py-2" [disabled]="form.invalid || isApplying()">
                                    {{isApplying() ? 'Applying..' : 'Apply for this job'}}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
<app-footer></app-footer>